<template>
	<div>
		<div class="vh-100 bg-grey">
			<SOTitleBar
				:page-title="'Paket Deposit'"
				:type="'back'"
				@back="back"
			/>

			<div class="content-wrapper list-paket-deposit-content main-page" v-if="listPaketDepositData.data">
				<SOCardPaketDepositCustomerInfo
					v-if="listPaketDepositData.data.jumlah_paket_nonaktif + listPaketDepositData.data.jumlah_paket_aktif !== 0 && listPaketDepositData.data.jumlah_paket_aktif !== 0"
					:info="listPaketDepositData.data"
				/>

				<div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
					<SOCardPaketDepositSkeleton/>
				</div>
				<!--<div class="p-x-20 p-t-16 p-d-72 w-limit" v-else>-->
				<div class="p-x-20 p-t-16 w-limit" v-else>
					<SOEmptyState
						v-if="listPaketDepositData.data.jumlah_paket_nonaktif + listPaketDepositData.data.jumlah_paket_aktif === 0"
						:message="'Belum ada paket deposit'"
						:sub-message="'Konsumen ini belum memiliki paket deposit.'"
					/>
					<SOWarningState
						v-else-if="listPaketDepositData.data.jumlah_paket_nonaktif + listPaketDepositData.data.jumlah_paket_aktif !== 0 && listPaketDepositData.data.jumlah_paket_aktif === 0"
						:message="'Tidak ada paket deposit yang aktif'"
						:sub-message="'Semua paket telah kedaluwarsa.'"
						:btn-text="'Lihat paket kedaluwarsa'"
					/>
					<SOEmptyState
						v-else-if="listPaketDepositData.data.jumlah_data === 0"
						:message="'Paket deposit tidak ditemukan'"
					/>

					<SOHeaderList
						v-if="listPaketDepositData.data.jumlah_paket_nonaktif + listPaketDepositData.data.jumlah_paket_aktif !== 0"
						:title="expired ? listPaketDepositData.data.jumlah_data + ' Paket Kedaluarsa' : listPaketDepositData.data.jumlah_data + ' Paket Aktif'"
						:show-filter="true"
						@filter="() => { pageSetting.showFilter = true }"
					/>

					<SOCardPaketDeposit
						v-for="paket in listPaketDepositData.data.list_paket_deposit"
						:key="paket.nama_paket_deposit"
						:paket="paket"
						:is-expired="expired"
						@detail="detailTransaksi(paket.iddata)"
					/>

					<SOLoadMoreLoading :id="'loading-list-paket-deposit'" :loading="pageSetting.loading.loadMore"/>
				</div>
			</div>

			<SOFilter
				v-if="pageSetting.showFilter"
				:filter-paket-deposit-konsumen="pageSetting.showFilter"
				:idcustomer="idcustomer"
				:sorting="sorting"
				@back="() => { pageSetting.showFilter = false }"
				@do-filter="doFilter"
				@reset-filter="resetFilter"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOCardPaketDepositCustomerInfo from "@/so-components/modules/paket-deposit/SOCardPaketDepositCustomerInfo";
import SOCardPaketDepositSkeleton from "@/so-components/modules/paket-deposit/SOCardPaketDepositSkeleton";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOWarningState from "@/so-components/global/ui/SOWarningState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOCardPaketDeposit from "@/so-components/modules/paket-deposit/SOCardPaketDeposit";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

import SOFilter from "@/so-components/global/filter/base/SOFilter";

export default {
	name: "PaketDeposit",
	components: {
		SOTitleBar,

		SOCardPaketDepositCustomerInfo,
		SOCardPaketDepositSkeleton,
		SOEmptyState,
		SOWarningState,
		SOHeaderList,
		SOCardPaketDeposit,
		SOLoadMoreLoading,

		SOFilter,
	},
	computed: {
		...mapGetters("depositModule", {
			listPaketDepositData: "getListPaketDeposit",
			pagination: "getPagination",
		}),
		...mapGetters("filterGlobalModule", {
			filter: "getFilter",
			filterItem: "getFilterItem",
		})
	},
	data() {
		return {
			idcustomer: "",
			sorting: [
				{
					label: "Abjad A-Z",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "abjad",
						orderBy: "ASC",
					}),
					id: "sorting-1"
				},
				{
					label: "Abjad Z-A",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "abjad",
						orderBy: "DESC",
					}),
					id: "sorting-2"
				},
				{
					label: "Masa aktif terlama",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "transaksi",
						orderBy: "DESC",
					}),
					id: "sorting-3"
				},
				{
					label: "Masa aktif terpendek",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "transaksi",
						orderBy: "ASC",
					}),
					id: "sorting-4"
				},
				{
					label: "Kuota teringgi",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "nominal",
						orderBy: "DESC",
					}),
					id: "sorting-5"
				},
				{
					label: "Kuota terendah",
					name: "sorting",
					value: JSON.stringify({
						sortBy: "nominal",
						orderBy: "ASC",
					}),
					id: "sorting-6"
				},
			],
			expired: false,
			pageSetting: {
				loading: {
					list: false,
					loadMore: false,
				},
				showFilter: false,
				error: {
					list: false,
				}
			},
		}
	},
	async mounted() {
		// await this.flushData()

		this.idcustomer = this.$route.params.idcustomer

		await this.setDefaultFilter()
		await this.listPaketDeposit()
		await this.scroll()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/detail/" + this.idcustomer)
			this.$router.back()
		},

		// fetch data
		async listPaketDeposit() {
			const res = await this.$store.dispatch("depositModule/fetchListPaketDeposit", this.idcustomer)
			if (!this.pageSetting.loading.list) {
				this.pageSetting.loading.loadMore = true
			} else {
				this.pageSetting.loading.list = false;
			}
			this.pageSetting.loading.loadMore = false
			this.$store.commit("helper/setScrollCalled", false)
			if (res.success) {
				this.pageSetting.error.list = false
				await this.$store.commit("depositModule/setNextPagination", {
					data: this.listPaketDepositData.data.list_paket_deposit
				})
			} else {
				this.pageSetting.error.list = true
				setTimeout(() => {
					this.pageSetting.error.list = false
				}, 10000)
				this.$toast.error(res.err)
			}
		},
		scroll() {
			window.onscroll = async () => {
				if (this.pageSetting.error.list) {
					return
				}
				let payload = {
					idLoadMore: "loading-list-paket-deposit",
					container: "list-paket-deposit-content",
					pagination: this.pagination,
					callback: this.listPaketDeposit,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},

		// func
		detailTransaksi(id) {
			this.$router.push("/konsumen/detail/paket_deposit/transaksi/" + this.idcustomer + "/" + id)
		},

		// filter
		async setDefaultFilter() {
			let query = this.$route.query
			await this.$store.commit("filterGlobalModule/resetFilterItem")
			if (Object.keys(query).length > 0) {
				let filterItem = this.filterItem
				if (query.kadaluarsa) filterItem.paketKedaluarsa = query.kadaluarsa === "0"
				if (query.masa_aktif_array) this.filterItem.masaAktif = (Array.isArray(query.masa_aktif_array)) ? query.masa_aktif_array : [query.masa_aktif_array]
				if (query.layanan_array) this.filterItem.layananTerhubung = (Array.isArray(query.layanan_array)) ? query.layanan_array : [query.layanan_array]

				await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

				let temp = this.filter
				temp.sortBy = query.sort_by
				temp.orderBy = query.order_by
				await this.$store.commit("filterGlobalModule/setFilter", temp)

				this.expired = this.filterItem.paketKedaluarsa
			} else {
				await this.resetFilter()
			}

			await this.$store.commit("depositModule/resetPagination")
		},
		async resetFilter() {
			let filterItem = this.filterItem
			filterItem.paketKedaluarsa = false
			await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

			let temp = this.filter
			temp.sortBy = "abjad"
			temp.orderBy = "ASC"
			await this.$store.commit("filterGlobalModule/setFilter", temp)
		},
		async doFilter() {
			this.pageSetting.loading.list = true
			await this.$store.commit("depositModule/resetPagination")
			await this.$store.commit("depositModule/resetListPaketDeposit")
			this.pageSetting.showFilter = false
			await this.listPaketDeposit()
			this.pageSetting.loading.list = false

			this.expired = this.filterItem.paketKedaluarsa
		},

		async flushData() {
			await this.$store.commit("depositModule/resetListPaketDeposit")
			await this.$store.commit("depositModule/resetPagination")
			await this.$store.commit("filterGlobalModule/resetFilter")
		}
	},
	beforeDestroy() {
		this.flushData()
	},
}
</script>